module.exports = __webpack_public_path__ + "img/08.9edd0e84.jpg";